import { useUserContext } from 'UserContext';
import { useFeatureFlag, FeatureFlag } from 'shared';

export function useFloridaClearinghouseNotice() {
    const { user } = useUserContext();
    const { featureActive } = useFeatureFlag(FeatureFlag.FLORIDA_CLEARINGHOUSE_MANUAL_CHECK);
    const isFloridaCenter = user?.address?.some((addr) => addr.state === 'Florida') ?? false;
    return { showFloridaClearinghouseNotice: featureActive && isFloridaCenter };
}
